import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import Modal from "../components/modal.react";
import InputWithError from "../components/inputWithError.react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";

export default class AddGallery extends Component {
  addGallery = () => {
    const {
      actions,
      sectionUID,
      notificationSystem,
      addGalleryFormProps,
      objectUID,
      afterAddSuccessAction
    } = this.props;
    let data = addGalleryFormProps.form.getIn(["fields"]).toJS();
    data.objectUID = objectUID;
    data.value = "";
    actions
      .createSectionGallery(data, sectionUID)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          afterAddSuccessAction(objectUID);
        }
      });
    actions.setIsAddGalleryModalVisible(false);
  };

  openAddGalleryModal = () => {
    const { actions, sectionUID } = this.props;
    actions.setIsAddGalleryModalVisible(sectionUID);
  };

  closeAddGalleryModal = () => {
    const { actions } = this.props;
    actions.setIsAddGalleryModalVisible(false);
  };

  render() {
    const { isAddModalVisible, sectionUID, addGalleryFormProps } = this.props;

    return (
      <div className="col-xs-12">
        <button className="info" onClick={this.openAddGalleryModal}>
          Dodaj galerię
        </button>
        {isAddModalVisible === sectionUID && (
          <Modal
            closeModalAction={this.closeAddGalleryModal}
            enterAction={this.addGallery}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs middle-xs">
              <h3 className="col-xs-12">Dodaj galerię</h3>
              <form className="col-xs-12">
                <div className="row middle-xs">
                  <label className="col-xs-12 col-sm-4">Nazwa galerii</label>
                  <div className="col-xs-12 col-sm-8">
                    <InputWithError {...addGalleryFormProps} field="name" />
                  </div>
                </div>
                <div className="row middle-xs">
                  <label className="col-xs-12 col-sm-4">Placeholder</label>
                  <div className="col-xs-12 col-sm-8">
                    <InputWithError
                      {...addGalleryFormProps}
                      field="placeholder"
                    />
                  </div>
                </div>
              </form>
              <div className="col-xs-12">
                <button className="info" onClick={this.addGallery}>
                  Dodaj
                </button>
                <button className="info" onClick={this.closeAddGalleryModal}>
                  Anuluj
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/template/addGallery.react.js